import { useContext, useEffect, useState } from "react";
import { TableDanhSachBenhNhan } from "./TableDanhSachBenhNhan";
import { AppContext } from "../../../appContext/AppContext";
import { Col, Form, Row, Button, InputGroup, FormCheck } from "react-bootstrap";
import InputSearch from '../../../component/InputSearch';
import { KhamLamSangContext, KhamLamSangContextProps } from "../tab-kham-lam-sang/KhamLamSang"
import { CODE, DEFAULT_PAGE_INDEX, KEY, MAX_PAGE_SIZE, RESPONSE_MESSAGE } from "../../../utils/Constant";
import { toast } from "react-toastify";
import { getListDsNhanVienKLS } from "../../services/KhamDoanHopDongServices"
import TextValidator from "../../../component/TextValidator";
import { LIST_PERIOD, TYPE_SEARCH } from "../../../component/filter-sidebar/FilterSidebar";
import ModalSearchAdvanced from "../../../component/modal-search-advanced/ModalSearchAdvanced";
import { formatDateToYYYYMMDD } from "../../../utils/FormatUtils";
type Props = {
  selectedRow: any;
  handlerCloseHD: any,
  setSelectedRow: (row: any) => void;
  setFilter: (data: any) => void;
};

const DanhSachBenhNhan = (props: Props) => {
  let {
    handlerCloseHD,
    selectedRow,
    setSelectedRow,
    setFilter,
  } = props;
  const { setIsLoading } = useContext(AppContext);
  const { TTHopDong, isSearchNV } = useContext<KhamLamSangContextProps>(KhamLamSangContext)
  const [countPaid, setCountPaid] = useState<any>();
  const [dsBenhNhan, setDsBenhNhan] = useState<any>({
    data: [],
    totalElements: 1,
    totalPages: 1,
    summaries: []
  });  
  const [keyword, setKeyword] = useState<any>(null);
  const [colorFilter, setColorFilter] = useState<any>('');
  const [shouldOpenModalSearchAdvanced, setShouldOpenModalSearchAdvanced] =
    useState<boolean>(false);
  const [period, setPeriod] = useState<any>(null);

  const getDanhSachBenhNhan = async () => {
    if (TTHopDong?.id) {
      setIsLoading(true);
      let searchObject = {
        pageIndex: DEFAULT_PAGE_INDEX,
        pageSize: MAX_PAGE_SIZE,
        keyword: keyword,
        contractId: TTHopDong?.id,
        color: colorFilter,
        fromDate: formatDateToYYYYMMDD(period?.fromDate),
			  toDate: formatDateToYYYYMMDD(period?.toDate),
      };
      
      try {
        const { data } = await getListDsNhanVienKLS(searchObject);
        if (CODE.SUCCESS === data?.code) {
          setDsBenhNhan({
            data: data?.data?.content || [],
            totalElements: data?.data?.totalElements,
            totalPages: data?.data?.totalPages,
            summaries: data?.data?.summaries || [],
          });
          setCountPaid({
            notPaidEnough: data?.data?.notPaidEnough,
            paidEnough: data?.data?.paidEnough,
          });
        } else {
          toast.warning(RESPONSE_MESSAGE.ERROR);
        }
      } catch {
        toast.warning(RESPONSE_MESSAGE.ERROR);
      } finally {
        setIsLoading(false);
      }
    } else {
      return setDsBenhNhan({
        data: [],
        totalElements: 1,
        totalPages: 1,
      })
    }
  };

  useEffect(() => {
    getDanhSachBenhNhan();
  }, [TTHopDong?.id, isSearchNV, colorFilter, period]);

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === KEY.ENTER) {
      getDanhSachBenhNhan()
    }
  };



  const getPeriod = (type: string) => {
    let fromDate = new Date();
    let toDate = new Date();

    switch (type) {
      case TYPE_SEARCH.TODAY:
        break;
      case TYPE_SEARCH.CURR_WEEK:
        const dayOfWeek = fromDate.getDay();
        fromDate.setDate(
          fromDate.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1)
        );
        toDate.setDate(
          toDate.getDate() + (dayOfWeek === 0 ? 0 : 7 - dayOfWeek)
        );
        break;
      case TYPE_SEARCH.CURR_MONTH:
        fromDate.setDate(1);
        toDate.setMonth(toDate.getMonth() + 1);
        toDate.setDate(0);
        break;
      case TYPE_SEARCH.YESTERDAT:
        fromDate.setDate(fromDate.getDate() - 1);
        toDate.setDate(toDate.getDate() - 1);
        break;
      case TYPE_SEARCH.LAST_SEVEN_DAYS:
        fromDate.setDate(fromDate.getDate() - 6);
        break;
      case TYPE_SEARCH.LAST_THIRTY_DAYS:
        fromDate.setDate(fromDate.getDate() - 29);
        break;
      case TYPE_SEARCH.NEXT_THREE_DAYS:
        fromDate.setDate(fromDate.getDate() + 1);
        toDate.setDate(toDate.getDate() + 3);
        break;
      case TYPE_SEARCH.NEXT_SEVEN_DAYS:
        fromDate.setDate(fromDate.getDate() + 1);
        toDate.setDate(toDate.getDate() + 7);
        break;
      case TYPE_SEARCH.SEARCH_ADVANCED:
        setShouldOpenModalSearchAdvanced(true);
        break;
      default:
        break;
    }
    return {
      fromDate,
      toDate,
    };
  };

  return (
    <div className="position-relative spaces gap-8 bg-white h-100">
      <div className="justify-content-between spaces pl-8 mb-8">
        <div className="d-flex mb-2 mt-1 ">
          <Col xs="7" className="spaces px-0 pt-0">
            <h4 className="text-title mb-0 fw-bold fs-4 spaces ">{"Danh sách bệnh nhân"}</h4>
          </Col>
          <Col xs="5" className="flex justify-content-end spaces pt-2 px-5 mt-3">
            <Button className="customer-buttom-dk spaces h-30 min-w-120" onClick={handlerCloseHD}>
              <span className="customer-buttom-text">DS Hợp Đồng</span>
            </Button>
          </Col>
        </div>
        {/* <div className="d-flex spaces mb-6 mr-5">
          <div className="flex-auto">
            <InputGroup className="spaces h-29 px-0">
              <TextValidator
                className="spaces h-29 min-w-177"
                name="keyword"
                placeholder="Tìm kiếm"
                value={keyword}
                onChange={(e: any) => {
                  setKeyword(e?.target?.value);
                }}
                onKeyDown={handleKeyPress} 
              />
              <Button
                className="btn-fill spaces min-w-105 h-29 rounded-end-1 z-index-1055"
                onClick={getDanhSachBenhNhan}
              >
                Tìm kiếm
              </Button>
            </InputGroup>
          </div>
        </div> */}
        <div className="d-flex spaces mb-6 mr-5">
        <div className="flex-auto">
          <InputGroup className="spaces h-29 px-0 flex-nowrap">
            <TextValidator
              className="spaces h-29"
              name="keyword"
              placeholder="Tìm kiếm"
              value={keyword}
              onChange={(e: any) => {
                setKeyword(e?.target?.value);
              }}
              onKeyDown={handleKeyPress}
            />
            <Button className="btn-fill spaces min-w-90" onClick={getDanhSachBenhNhan}>
              Tìm kiếm
            </Button>
            <Button
              className="btn-fill rounded-end-1 z-index-99 w-30px d-flex"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{
                borderLeft: "1px solid #fff",
              }}
            >
              <i className="bi bi-caret-down-fill fs-8 m-0 p-0" />
              <ul className="dropdown-menu filter-dropdown">
                {LIST_PERIOD.map(
                  (
                    item: {
                      type: string | null;
                      name: string;
                    },
                    index: number
                  ) => {
                    return !!item.name.trim() ? (
                      <li
                        key={index}
                        className="dropdown-item"
                        onClick={() => {
                          if (item.type) {
                            let newPeriod = getPeriod(item.type);
                            item.type !== TYPE_SEARCH.SEARCH_ADVANCED &&
                              setPeriod(newPeriod);
                          }
                        }}
                      >
                        {item.name}
                      </li>
                    ) : (
                      <li key={index} className="dropdown-divider"></li>
                    );
                  }
                )}
              </ul>
            </Button>
          </InputGroup>
        </div>
      </div>
      </div>
      <div className="flex-1 flex flex-column">
        <TableDanhSachBenhNhan
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          dsBenhNhan={dsBenhNhan?.data}
          countPaid={countPaid}
          summaries={dsBenhNhan?.summaries || []}
          setColorFilter={setColorFilter}
        />
      </div>
      {shouldOpenModalSearchAdvanced && (
        <ModalSearchAdvanced
          getPeriod={getPeriod}
          setPeriod={setPeriod}
          handleCloseModal={() => setShouldOpenModalSearchAdvanced(false)}
        />
      )}
    </div >
  );
};

export default DanhSachBenhNhan;
